import { useMutation, useQuery, useQueryClient } from "react-query";
import { OrganizationKeyName } from "../../../../model/Organization";
import { productGroupsHttp } from "./product-groups-http";

const cacheKeys = {
  productGroups: "productGroups",
  productGroup: "productGroup",
};

export const useGetProductGroups = (
  organizationKeyName?: OrganizationKeyName
) => {
  return useQuery(
    [cacheKeys.productGroups, organizationKeyName],
    () => productGroupsHttp.getProductGroups(organizationKeyName),
    { refetchOnWindowFocus: false, enabled: !!organizationKeyName }
  );
};

export const useGetProductGroup = (
  organizationKeyName?: OrganizationKeyName,
  id?: string
) => {
  return useQuery(
    [cacheKeys.productGroup, id],
    () => productGroupsHttp.getProductGroup(organizationKeyName, id),
    { refetchOnWindowFocus: false, enabled: !!id && !!organizationKeyName }
  );
};

export const useCreateProductGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(productGroupsHttp.createProductGroup, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.productGroups]);
    },
  });
};

export const useDeleteProductGroup = () => {
  const queryClient = useQueryClient();

  return useMutation(productGroupsHttp.deleteProductGroup, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.productGroups]);
    },
  });
};

export const useUpdateProductGroup = (id: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation(productGroupsHttp.updateProductGroup, {
    onSuccess: async () => {
      queryClient.refetchQueries([cacheKeys.productGroups]);
      if (id) {
        queryClient.refetchQueries([cacheKeys.productGroup, id]);
      }
    },
  });
};
